// extracted by mini-css-extract-plugin
module.exports = {"vhfLogoContainer":"VirgilLogo-module--vhfLogoContainer--1tX6y","vhfLogo":"VirgilLogo-module--vhfLogo--2NPqo"};